import { IApiResponse, IStop } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { TTL } from "../../Lib/Utils/TTL";

// Coalesce concurrent calls: several startup consumers (StopManager,
// GetDepartureFromListAction, ...) request stops at the same instant, all
// missing the response cache before the first answer lands. Completed
// requests are served by the "classic" cache below, so the in-flight
// promise is cleared once settled.
let inflight: Promise<IApiResponse<{ stops: IStop[] }>> | null = null;

export async function getStops(showLoader: boolean = true): Promise<IApiResponse<{ stops: IStop[] }>> {
    if (inflight) return inflight;
    inflight = (async () => {
        try {
            const ENDPOINTS = await getEndpoints();
            const endpoint = ENDPOINTS.getStops;
            // 5 minutes, NOT a day: the backend adds stops (e.g. the City Centre
            // Fujairah shuttle) without a deploy, and a 24h entry hid them for a
            // full day — hard reloads and new tabs included, since `persist`
            // mirrors this to localStorage. "classic" stamps the expiry once at
            // write, so this only applies to entries written from here on;
            // clients holding an older entry keep its 24h expiry until it lapses.
            //
            // The TTL goes in ttlOverride (last arg), NOT customTTL: the backend
            // cache config replaces customTTL wholesale (ApiRequest.ts), so a
            // config entry for this path would otherwise silently restore a long
            // TTL and bring the bug straight back.
            return await apiRequest<{ stops: IStop[] }>(endpoint, 'GET', {}, "classic", undefined, undefined, showLoader, true, true, TTL.MIN_5);
        } finally {
            inflight = null;
        }
    })();
    return inflight;
}
